import React from 'react'

const SearchIcon = ({ width = 20, height = 20, color = "#707A89", ...props }) => {
  return (
    <svg 
      width={width} 
      height={height} 
      viewBox="0 0 20 20" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask id="search_icon_mask" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
        <path d="M15.176 13.7618L19.7071 18.2929C20.0976 18.6834 20.0976 19.3166 19.7071 19.7071C19.3166 20.0976 18.6834 20.0976 18.2929 19.7071L13.7618 15.176C12.3145 16.3183 10.4869 17 8.5 17C3.80558 17 0 13.1944 0 8.5C0 3.80558 3.80558 0 8.5 0C13.1944 0 17 3.80558 17 8.5C17 10.4869 16.3183 12.3145 15.176 13.7618ZM13.1598 13.0317C14.2986 11.8609 15 10.2624 15 8.5C15 4.91015 12.0899 2 8.5 2C4.91015 2 2 4.91015 2 8.5C2 12.0899 4.91015 15 8.5 15C10.2624 15 11.8609 14.2986 13.0317 13.1598C13.0509 13.1368 13.0713 13.1145 13.0929 13.0929C13.1145 13.0713 13.1368 13.0509 13.1598 13.0317Z" fill="white"/>
      </mask>
      <g mask="url(#search_icon_mask)">
        <path d="M15.176 13.7618L19.7071 18.2929C20.0976 18.6834 20.0976 19.3166 19.7071 19.7071C19.3166 20.0976 18.6834 20.0976 18.2929 19.7071L13.7618 15.176C12.3145 16.3183 10.4869 17 8.5 17C3.80558 17 0 13.1944 0 8.5C0 3.80558 3.80558 0 8.5 0C13.1944 0 17 3.80558 17 8.5C17 10.4869 16.3183 12.3145 15.176 13.7618ZM13.1598 13.0317C14.2986 11.8609 15 10.2624 15 8.5C15 4.91015 12.0899 2 8.5 2C4.91015 2 2 4.91015 2 8.5C2 12.0899 4.91015 15 8.5 15C10.2624 15 11.8609 14.2986 13.0317 13.1598C13.0509 13.1368 13.0713 13.1145 13.0929 13.0929C13.1145 13.0713 13.1368 13.0509 13.1598 13.0317Z" fill={color}/>
      </g>
    </svg>
  )
}

export default SearchIcon